import { render } from "./PantryImageSelectView.vue?vue&type=template&id=3aaa10fb&ts=true"
import script from "./PantryImageSelectView.vue?vue&type=script&lang=ts"
export * from "./PantryImageSelectView.vue?vue&type=script&lang=ts"

import "./PantryImageSelectView.vue?vue&type=style&index=0&id=3aaa10fb&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__